import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CriticalAlertBannerService {
  private refreshCriticalAlertBannerSubject = new Subject<void>();
  public criticalAlertsCount = new Subject<number>();

  refreshCriticalAlertBanner$ =
    this.refreshCriticalAlertBannerSubject.asObservable();

  refreshCriticalAlertBanner() {
    this.refreshCriticalAlertBannerSubject.next();
  }
}
